import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled, { css } from 'styled-components';
import { color, pixelToRem, propsBlocker, spacing, typography } from '../../../system';

var getSearchSuggestionListGroupDynamicStyle = function getSearchSuggestionListGroupDynamicStyle(_ref) {
  var enableSeparator = _ref.enableSeparator;
  var result = {};

  if (enableSeparator) {
    result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            border-top: 1px solid ", ";\n            padding-top: ", ";\n        "])), color('neutral.02'), spacing(10));
  }

  return result;
};

export var SearchSuggestionListGroup = styled.div.withConfig(propsBlocker)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: ", " ", " ", " ", ";\n    ", ";\n    font-size: ", ";\n    color: ", ";\n    ", ";\n"])), spacing(6), spacing(4), spacing(2), spacing(4), typography('labelMedium'), pixelToRem(14), color('neutral.05'), getSearchSuggestionListGroupDynamicStyle);